/*
 * Copyright (c) 2023. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { useMsal } from '@azure/msal-react';
import type { APIPermissions } from '@poweralpha/common';
import { useMemo } from 'react';

export { pca } from './authClient';

export interface AuthenticatedUser {
  name: string | undefined;
  nickname: string;
  email: string;
}

export const useAuth = (): { user: AuthenticatedUser | undefined } => {
  const { accounts } = useMsal();
  const account = accounts.at(0);

  const user = useMemo(
    () =>
      account
        ? {
            nickname: account.username.split('@')[0],
            email: account.username,
            name: account.name,
          }
        : undefined,
    [account],
  );
  return useMemo(() => ({ user }), [user]);
};

export const usePermissions = (): APIPermissions[] | undefined => {
  const { accounts } = useMsal();
  return accounts.at(0)?.idTokenClaims?.roles as APIPermissions[] | undefined;
};
